import React from 'react';
import ReservationScreen from './ReservationScreen';

function PayingGuestReservationScreen() {
  return <ReservationScreen reservationType="paying-guest" />;
}

export default PayingGuestReservationScreen;
